<!--  -->
<template>
  <div>
    <div style="float: right">
      <el-button class="addbutton" plain type="primary" @click="addRules">新增日报规则</el-button>
    </div>

    <template>
      <el-table v-loading="loading" border :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="name" label="模板名称" />
        <el-table-column align="center" prop="type_text" label="模板类型" />
        <el-table-column align="center" prop="department_text" label="部门" />
        <!-- <el-table-column align="center" prop="corn_time" label="汇报时间" /> -->
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="editConfig(scope.row)">编辑</el-button>
            <el-button type="warning" size="mini" @click="boundEnterprise(scope.row)">查看绑定企业</el-button>
            <el-button type="danger" size="mini" @click="deleteConfig(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right :current-page="query.page" :total="total" @size-change="fetchPageSize" @current-change="fetchCurrentPage" />
    </template>

    <el-dialog title="绑定企业信息" :close-on-click-modal="false" :visible.sync="viewDialog" :destroy-on-close="true" :append-to-body="true" width="40%">
      <div>
        <boundDialog ref="bounddialogview" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { reportList } from '@/api/tencentAccountIni'
import boundDialog from './boundDialog.vue'

export default {
  name: 'Report',
  // eslint-disable-next-line vue/no-unused-components
  components: { PaginationRight, boundDialog },
  data() {
    return {
      tableData: [],
      loading: false,
      query: {
        type: 1,
        page: 1,
        page_size: 10
      },
      total: null,
      viewDialog: false
    }
  },
  mounted() {
    this.list()
  },
  beforeDestroy() {
    this.tableData = []
  },
  methods: {
    async list() {
      this.loading = true
      const data = await reportList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    // 新增汇报规则
    addRules() {
      this.$router.push({ path: '/addReportRules/index', query: { type: 1 }})
    },
    editConfig(row) {
      this.$router.push({ path: '/updateReportRules/index', query: { type: 1, id: row.id, row: row }})
    },
    boundEnterprise(row) {
      this.viewDialog = true
      this.$nextTick(() => {
        this.$refs.bounddialogview.send(row)
      })
    },
    deleteConfig() {},
    // 分页
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    addConfig() {},
    rowClass() {}
  }
}
</script>
<style scoped>
.addbutton {
  margin-bottom: 20px;
}
</style>
